import { getPhrase } from './phrases';
import { setLoggedOut } from './session';

export function processException(ex, url) {
	if (typeof ex === 'string') {
		return ex;
	}
	let msg = '';
	if (ex.response && ex.response.text) {
		msg = ex.response.text;
	}
	const status = ex.status;
	if (status === 401) {
		setLoggedOut();
		ex = 'unauthorizedAccess';
	} else if (msg === 'userInvalidLogin' || msg === 'errorSendingSms' || msg === 'invalidAuthenticationCode' || msg === 'authenticationCodeExpired' || msg === 'userInvalidPassword' || msg === 'userExpired') {
		ex = msg;
	} else if (msg.indexOf('UK_PORTAL_USER_USER_NAME') >= 0) {
		ex = {
			customMessage: getPhrase('duplicateUserName')
		};
	} else if (msg.indexOf('UK_PRODUCER_LABEL') >= 0) {
		ex = {
			customMessage: getPhrase('duplicateLabelName')
		};
	} else if (msg.indexOf('eloUnavailable') >= 0) {
		ex = {
			customMessage: getPhrase('eloUnavailable')
		};
	} else if (status === 500) {
		let idx = msg.indexOf('ORA-20000');
		if (idx >= 0) {
			idx += 10;
			let endIdx = msg.indexOf('\n', idx);
			if (endIdx < 0) {
				endIdx = msg.length;
			}
			ex = {
				customMessage: msg.substring(idx, endIdx)
			};
		}
	}
	return ex;
}
